import React, { useEffect, useState } from 'react';
import { colors } from '../../config/constants';
import { ClickAwayListener } from '@mui/material';

type DataProps = { name: string; id: string };

type RootFilterProps = {
  Heading: string;
  data: DataProps[];
};
interface FilterProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterHandler: (arg: any) => void;
  rootFilter: RootFilterProps[];
  initialFilterData?: filterArrayProps[];
}

type filterArrayProps = {
  type: string;
  selectedMenu: Array<string | number>;
};

const MultipleFilter = (props: FilterProps) => {
  const { filterHandler, rootFilter, initialFilterData } = props;
  const [openDropdown, setOpenDropDown] = useState<boolean>(false);
  const [arr, setArr] = useState<filterArrayProps[]>([]);
  const [filterCount, setFilterCount] = useState<number>(0);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedMenu, setSelectedMenu] = useState('');

  useEffect(() => {
    if (initialFilterData?.length) {
      let filterLength = 0;
      setArr([...initialFilterData]);
      initialFilterData.forEach((item) => {
        if (item.selectedMenu.length) {
          filterLength = filterLength + item.selectedMenu.length;
        }
      });
      setFilterCount(filterLength);
    }
  }, []);

  const getInfo = (type: string, menuItem: string) => {
    if (arr?.some((arr: filterArrayProps) => arr.type === type)) {
      const arrIndex = arr?.findIndex((ele: filterArrayProps) => ele.type === type);
      const initialFilterArr = [...arr];
      if ((arr[arrIndex] as filterArrayProps)?.selectedMenu?.includes(menuItem)) {
        const selectedMenuIndex = (
          initialFilterArr[arrIndex] as filterArrayProps
        )?.selectedMenu?.indexOf(menuItem);
        (initialFilterArr[arrIndex] as filterArrayProps)?.selectedMenu?.splice(
          selectedMenuIndex,
          1
        );
        setArr([...initialFilterArr]);
      } else {
        (initialFilterArr[arrIndex] as filterArrayProps)?.selectedMenu?.push(
          menuItem
        );
        setArr([...initialFilterArr]);
      }
    } else {
      arr.push({
        type,
        selectedMenu: [menuItem],
      });
    }
  };

  const onClickFilter = () => {
    filterHandler(arr);
    const countArray = [];
    const lengthArray = [];
    if (arr.length > 0) {
      for (let i = 0; i < arr?.length; i++) {
        countArray?.push(arr[i]?.selectedMenu);
      }

      for (let j = 0; j < countArray?.length; j++) {
        lengthArray?.push(...countArray[j]);
      }
    }
    setFilterCount(lengthArray?.length);
    setOpenDropDown(false);
  };
  const handleOnChange = (menuValue: string) => {
    setSelectedMenu(menuValue);
  };

  return (
    <div
      className={`relative cursor-pointer ${colors.primaryText} z-20`}
      data-testid="MultipleFilter-wrapper"
    >
      <div
        className="w-full sm:w-fit flex items-center border rounded-sm"
        data-testid="filters-applied"
        onClick={() => setOpenDropDown(true)}
      >
        <div className="sm:w-[332px] w-full  h-8 bg-white  text-sm flex items-center justify-start pl-2 ">
          No of Filter(s) Applied : {filterCount}
        </div>

        <div
          className={`h-8 w-8 flex items-center justify-center text-white ${colors.primary}`}
        >
          <i className="fa-solid fa-filter"></i>
        </div>
      </div>

      {openDropdown && (
        <ClickAwayListener
          onClickAway={() => {
            setOpenDropDown(false);
            onClickFilter();
          }}
        >
          <div
            className={`absolute max-h-[420px] overflow-scroll text-black border  z-50 text-sm shadow-lg sm:top-9  rounded bg-white sm:mx-2  sm:w-[332px] w-full`}
            data-testid="filterlist-wrapper"
          >
            {rootFilter.length > 0 ? (
              <>
                {rootFilter.map((item: RootFilterProps, index: number) => {
                  return (
                    <div className="p-2" key={index}>
                      <div className={`${colors.primaryText} my-1`}>
                        {item.Heading}
                      </div>
                      <div className="px-2 cursor-pointer">
                        {item.data.map(
                          (content: { name: string; id: string }, i: number) => {
                            return (
                              <div
                                key={i}
                                data-testid={`filter-item-${index}-${i}`}
                                className="flex space-x-2 mb-1"
                                onClick={() => {
                                  getInfo(item.Heading, content.id);
                                  handleOnChange(content.id);
                                }}
                              >
                                <div>
                                  <input
                                    type="checkbox"
                                    className="h-4 w-4 cursor-pointer"
                                    value={content.id}
                                    data-testid={`filter-checkbox-${index}-${i}`}
                                    checked={(
                                      arr?.filter(
                                        (ele: filterArrayProps) =>
                                          ele.type === item.Heading
                                      )[0] as filterArrayProps
                                    )?.selectedMenu?.includes(content.id)}
                                  />
                                </div>
                                <div>{content.name}</div>
                              </div>
                            );
                          }
                        )}
                      </div>{' '}
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="mb-2 text-sm text-black ">No records Found</div>
            )}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default MultipleFilter;
